import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const OptionWithIconCardStyles = makeStyles((theme) => ({
  linkContainer: { textDecoration: "none" },
  container: {
    background: COLORS.WHITE,
    padding: 25,
    borderRadius: 10,
    border: `1px solid ${COLORS.GRAY}`,
    minHeight: 260,
    color: COLORS.DARK_GRAY_2,
    fontFamily: "Inter, sans-serif"
  },
  icon: { height: 75 },
  header: { marginTop: 20 },
  text: { marginTop: 20 }
}));

export default OptionWithIconCardStyles;
